import {TranslateService} from '@ngx-translate/core';
import {MenuItem} from 'primeng/api';
import {Router} from '@angular/router';
import {CCRolesType} from '../../model/security/cc-roles-type';

export class PageDescription {
  readonly label: string;
  readonly path?: string = undefined;
  readonly icon?: string = undefined;
  readonly roles: CCRolesType.Roles[];

  public static toMenuItem(pdesc: PageDescription, translateService: TranslateService,
                           router: Router, userRoles: CCRolesType.Roles[],
                           iconOnly: boolean = false, subItems: MenuItem[] = [],
                           enabled: boolean = true): MenuItem {
    let isVisible = this.isVisible(userRoles, pdesc) && enabled;
    const menuItem: MenuItem = {
      label: iconOnly ? '' : translateService.instant(pdesc.label),
      icon: pdesc.icon ? pdesc.icon : '',
      escape: false,
      styleClass: (iconOnly ? 'icon-only' : ''),
      visible: isVisible,
      items: subItems && subItems.length === 0 ? undefined : subItems,
      id: pdesc.path
    };
    if (pdesc.path) {
      menuItem.command = () => {
        router.navigate([pdesc.path]);
      };
    }

    return menuItem;
  }

  public static isVisible(userRoles: CCRolesType.Roles[], pdesc: PageDescription) {
    let isVisible: boolean = false;
    if (userRoles && pdesc.roles) {
      userRoles.forEach(userRole => {
        if (pdesc.roles.includes(userRole)) {
          isVisible = true;
        }
      });
    }
    return isVisible;
  }
}
